import { useContext, React, useState } from 'react';

import { Link } from "react-router-dom";
import { CartContext } from '../context/CartContext';


const Carrito = () => {

  const { removeItem, cart, precioTotal } = useContext(CartContext);


  return (
    <>
      <div >
        {cart.length ?
          <>
            <div style={{ height: "80px" }}>
              <Link to="/" className='link-volver'>
                <div className="link-volver-carrito">
                  <i class="fa-solid fa-arrow-left fa-2x"></i>
                </div>
              </Link>
            </div>
            <span style={{
              padding: "18px",
              paddingBottom: "20px",
              fontSize: "25px",
              fontWeight: "550"
            }}>Estás llevando:</span>
            <ul >
              {cart.map((item, index) =>
                <li className='carrito-item' key={index} id="cart">
                  <div className='carrito-info'>
                    <div className='carrito-nombre-img'>
                      <img className='carrito-img' src={item.producto.img} alt={item.producto.nombre} />
                      <div className='carrito-nombre-precio'>
                        <h2 className='carrito-nombre'>X{item.cantidad} de {item.producto.nombre}</h2>
                        <h3 className='carrito-precio'>${item.producto.precio}</h3>
                      </div>
                    </div>

                    <span className='carrito-img' onClick={() => removeItem(item.producto)}><i class="fa fa-trash-o  fa-2x" aria-hidden="true"></i></span>
                  </div>
                  <hr className='carrito-line'></hr>
                </li>
              )}
            </ul>
            <div style={{
              paddingLeft: "15px"
            }}>
              <span style={{
              fontWeight: "700",
              fontSize: "18.5px",
              paddingRight: "10px"
            }}>SubTotal:</span>
              <span>${precioTotal}</span>
            </div>
            <Link className='link-carrito' to="/checkout" >
              <button className='carrito-btn'>Continuar</button>
            </Link>
          </>
          :
          <div className='carrito-vacio'>

            <span className='carrito-' >Tu carrito esta vacio :(</span>
            <Link to="/" className='btn-volver-tienda'>
              Volver a la Tienda
            </Link>
          </div>
        }
      </div>
    </>
  )
}

export default Carrito